import { LocationError, getLocation } from "../lib/location";
import { isAuthenticated } from "../services/auth";

const template = document.createElement("template");
template.innerHTML = `
	<style>
		:host {
			display: block;
			position: fixed;
			inset: 0;
			overflow: hidden;
		}

		map-view, onboarding-flow {
			width: 100%;
			height: 100%;
		}

		.loading, .error {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
		}

		.loading-text {
			color: var(--color-text-muted);
		}

		.error-text {
			color: var(--color-accent);
			text-align: center;
		}
	</style>
	<div class="loading">
		<span class="loading-text">Loading...</span>
	</div>
`;

class AppRoot extends HTMLElement {
	constructor() {
		super();
		this.attachShadow({ mode: "open" });
		this.shadowRoot!.appendChild(template.content.cloneNode(true));
	}

	connectedCallback() {
		this.addEventListener("register-complete", this.handleRegisterComplete.bind(this));
		this.checkAuthAndRender();
	}

	private async checkAuthAndRender() {
		const authenticated = await isAuthenticated();
		if (authenticated) {
			this.showMap();
		} else {
			this.showOnboarding();
		}
	}

	private handleRegisterComplete() {
		this.showMap();
	}

	private showOnboarding() {
		this.shadowRoot!.innerHTML = `
			<style>
				:host {
					display: block;
					position: fixed;
					inset: 0;
					overflow: hidden;
				}
				onboarding-flow {
					width: 100%;
					height: 100%;
				}
			</style>
			<onboarding-flow></onboarding-flow>
		`;
	}

	private async showMap() {
		this.shadowRoot!.innerHTML = `
			<style>
				:host {
					display: block;
					position: fixed;
					inset: 0;
					overflow: hidden;
				}
				map-view {
					width: 100%;
					height: 100%;
				}
				.loading, .error {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 100%;
					height: 100%;
				}
				.loading-text {
					color: var(--color-text-muted);
				}
				.error-text {
					color: var(--color-accent);
					text-align: center;
				}
			</style>
			<div class="loading">
				<span class="loading-text">Locating...</span>
			</div>
		`;

		try {
			const result = await getLocation();
			const lat = result.coords.latitude;
			const lng = result.coords.longitude;
			this.shadowRoot!.innerHTML = `
				<style>
					:host {
						display: block;
						position: fixed;
						inset: 0;
						overflow: hidden;
					}
					map-view {
						width: 100%;
						height: 100%;
					}
				</style>
				<map-view latitude="${lat}" longitude="${lng}"></map-view>
			`;
		} catch (error) {
			const message = error instanceof LocationError ? error.message : "Failed to get location";
			this.shadowRoot!.querySelector(".loading")!.outerHTML = `
				<div class="error">
					<span class="error-text">${message}</span>
				</div>
			`;
		}
	}
}

customElements.define("app-root", AppRoot);
